import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSpring, animated, easings } from '@react-spring/web';
import { ReactSVG } from 'react-svg';
import logo from '../../assets/logo.svg';
import sunRays from '../../assets/backgrounds/sun_rays.svg';
import '../Slides.scss';
import './OtherSlides.scss';

const ErrorSlide = ({ refreshFunc }) => {

  const [fadeInDone, setFadeInDone] = useState(false);

  const logoSpring = useSpring({
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    delay: 200,
  });


  const subTitleSpring = useSpring({
    from: { opacity: 0, transform: 'translateX(-100px)' },
    to: { opacity: 1, transform: 'translateX(0px)' },
    delay: 600,
    config: {
      tension: 180,
      friction: 12,
    },
  });

  const boxSpring = useSpring({
    from: { opacity: 0, transform: 'translateY(100vh)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    delay: 800,
  });

  const sunSpring = useSpring({
    from: { opacity: 0, transform: 'translateY(100vh)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    delay: 1000,
  });

  const sunRaysFadeInSpring = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 1000 },
    delay: 1000,
    onRest: () => setFadeInDone(true),
  });

  const sunRaysScaleSpring = useSpring({
    from: { scale: 1 },
    to: { scale: 1.1 },
    loop: fadeInDone ? { reverse: true } : false,
    config: { duration: 1500, easing: easings.easeInOutSine },
  });

  const sunRaysSpring = {
    ...sunRaysFadeInSpring,
    ...sunRaysScaleSpring,
  };

  const buttonSpring = useSpring({
    from: { opacity: 0, transform: 'scale(0.5)' },
    to: { opacity: 1, transform: 'scale(1)' },
    delay: 1400,
    config: { duration: 500 },
  });

  return (
    <div className='Slide__error'>
      <animated.div className='Slide__error__logo' style={logoSpring}>
        <ReactSVG src={logo} />
      </animated.div>
      <animated.h3 className='Slide__error__subTitle' style={subTitleSpring}>Oops, something went wrong...</animated.h3>
      <animated.button className='Slide__error__button' style={buttonSpring} type='button' onClick={refreshFunc}>
        refresh
      </animated.button>
      <animated.div className='Slide__error__box' style={boxSpring} />
      <animated.div className='Slide__error__sun' style={sunSpring} />
      <animated.div className='Slide__error__sunRays' style={sunRaysSpring}>
        <ReactSVG src={sunRays} />
      </animated.div>
    </div>
  );
};

export default ErrorSlide;


ErrorSlide.propTypes = {
  refreshFunc: PropTypes.func.isRequired,
};
